import type { FilterDefinition } from '@atlassian/mpac-primitives';

const newFilterDefinitions: FilterDefinition[] = [
  {
    filterId: 'billingModel',
    label: 'Billing',
    isMulti: true,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: true,
  },
];

export const defaultFilterDefinitions: FilterDefinition[] = [
  {
    filterId: 'useCases',
    label: 'Use cases',
    isMulti: true,
    isSearchable: true,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: true,
  },
  {
    filterId: 'product',
    label: 'Product',
    isMulti: false,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: false,
  },
  {
    filterId: 'hosting',
    label: 'Hosting',
    isMulti: false,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: false,
  },
  {
    filterId: 'price',
    label: 'Pricing',
    isMulti: true,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: true,
  },
  {
    filterId: 'trustSignals',
    label: 'Trust signals',
    isMulti: true,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: true,
  },
  {
    filterId: 'other',
    label: 'More filters',
    isMulti: true,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: true,
  },
];

export const transformedCategoryFilterDefinitions: FilterDefinition[] = [
  ...defaultFilterDefinitions.slice(0, 4),
  ...newFilterDefinitions,
  ...defaultFilterDefinitions.slice(4),
];
